import { useState, type FormEvent } from "react";

import { ApiError } from "@/lib/http";

import { useAuth } from "../AuthContext";

/**
 * A porta de entrada.
 *
 * UMA MENSAGEM DE ERRO SO, de proposito. Usuario inexistente e senha errada
 * dizem exatamente a mesma coisa — do contrario a tela vira um verificador de
 * quem tem conta na empresa, e numa planta com dezenas de pessoas isso e
 * informacao util para quem nao deveria te-la. O servidor ja faz a parte
 * dificil desse disfarce (gasta o mesmo tempo nos dois casos); aqui e so nao
 * estragar.
 */
export function LoginPage() {
  const { entrar, erroDeBoot } = useAuth();
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function aoEnviar(evento: FormEvent) {
    evento.preventDefault();
    if (enviando) return;
    setEnviando(true);
    setErro(null);
    try {
      await entrar(login.trim(), senha);
    } catch (falha) {
      if (falha instanceof ApiError && falha.isNetwork) {
        setErro("Não foi possível falar com o servidor. Verifique a conexão.");
      } else if (falha instanceof ApiError && falha.status === 401) {
        setErro("Login ou senha incorretos.");
      } else {
        setErro("Não foi possível entrar. Tente de novo em instantes.");
      }
      setSenha("");
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={aoEnviar}>
        <div className="login-brand">
          <b>GHM</b>
          <small>Industrial Intel</small>
        </div>

        <h1 className="login-title">Entrar</h1>
        <p className="login-sub">Acesse o painel da sua planta.</p>

        {erroDeBoot ? <div className="form-error">{erroDeBoot}</div> : null}

        <label className="field">
          <span className="field__label">Login</span>
          <input
            className="input"
            type="text"
            name="login"
            autoComplete="username"
            autoFocus
            required
            value={login}
            onChange={(e) => setLogin(e.target.value)}
          />
        </label>

        <label className="field">
          <span className="field__label">Senha</span>
          <input
            className="input"
            type="password"
            name="senha"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </label>

        {/* `role="alert"` para o leitor de tela anunciar a falha sem que a
            pessoa precise voltar o foco ate aqui. */}
        {erro ? (
          <div className="form-error" role="alert">
            {erro}
          </div>
        ) : null}

        <button className="btn primary login-submit" type="submit" disabled={enviando}>
          {enviando ? "Entrando..." : "Entrar"}
        </button>

        <p className="login-ajuda">
          Não tem acesso? Fale com o administrador da sua organização — as contas
          são criadas por ele.
        </p>
      </form>
    </div>
  );
}
